import { ConfigServiceDataKeys, QueryParamKeys } from './constants';
import { ParentDataKeys } from './messages';
// ConfigKeys contains the union of the config, parent, and query parameter keys
export const ConfigKeys = Object.assign(Object.assign(Object.assign({}, ConfigServiceDataKeys), ParentDataKeys), QueryParamKeys);
// List of PII related fields to be redacted from queryStrings in server logs
export const CONFIG_KEY_REDACT_LIST = [
    ConfigKeys.AddressOne,
    ConfigKeys.AddressTwo,
    ConfigKeys.City,
    ConfigKeys.DateOfBirth,
    ConfigKeys.Email,
    ConfigKeys.FirstName,
    ConfigKeys.LastName,
    ConfigKeys.PrimaryPhone,
    ConfigKeys.Referrer,
    ConfigKeys.State,
    ConfigKeys.Zipcode,
];
//# sourceMappingURL=others.js.map